/* eslint-disable import/prefer-default-export */
import headers from "./headers";

export const create = (params) => (
  fetch("/api/public/user", {
    body: JSON.stringify(params),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);
